import * as R from 'ramda';
import { identity, ifElse } from 'ramda';


const liftedObjOf: any = R.lift(R.objOf);

export const isString = R.is(String);
export const isNumber = R.is(Number);
export const isBoolean = R.is(Boolean);
export const isValidNumber = value => !Number.isNaN(value);
export const startsWith = R.curry((value, startValue) => R.startsWith(startValue)(value));

export const isDefined = R.complement(R.equals(undefined));
export const isNotEqual: any = R.complement(R.equals);
export const isNotNil: any = R.complement(R.isNil);
export const isNotEmpty: any = R.complement(R.isEmpty);

type HasValue = (v: any) => boolean;
export const hasValue: HasValue = R.allPass([isNotEmpty, isNotNil]);
export const hasNoValue: HasValue = R.complement(hasValue);

// Object
export const isObject = R.is(Object);
export const containsNonEmptyValues: any = R.compose(R.any(hasValue), R.values);
export const containsOnlyEmptyValues: any = R.complement(containsNonEmptyValues);
export const mergeNonNull = R.mergeDeepWith((x, y) => isNotNil(x) ? x : y);
export const toObjByProp: any = propName => liftedObjOf(R.prop(propName), R.identity);
export const toObjectsByIds: any = R.compose(R.mergeAll, R.map(toObjByProp('id')));
export const toObjectsByIndex: any = R.compose(R.mergeAll, R.map(toObjByProp('index')));
export const keysAsNumbers: any = R.compose(R.map(Number), R.keys);

// Array
export const isArray = R.is(Array);
export const isSingleton = R.compose(R.equals(1), R.length);
export const containsMoreThanNElements = (numberOfElements: number) => R.compose(R.lt(numberOfElements), R.length);
export const containsMoreThanOneElement = containsMoreThanNElements(1);
export const containsMoreThanTwoElement = containsMoreThanNElements(2);
export const forEachIndexed: any = R.addIndex(R.forEach);
export const mapIndexed: any = R.addIndex(R.map);
export const allNumbers: any = R.allPass([isNotEmpty, R.all(isNumber)]);
export const allBooleans: any = R.allPass([isNotEmpty, R.all(isBoolean)]);
const toSingletonArray = obj => [obj];
export const toArray = ifElse(isArray, identity, toSingletonArray);

// Boolean
type BooleanCheck = (v: boolean) => boolean;
export const isTrue: BooleanCheck = R.equals(true);
export const isFalse: BooleanCheck = R.complement(isTrue);

// Function
export const isFunction = R.is(Function);
